import React from 'react'
import { useTranslation } from 'react-i18next'
import InteractiveDialog from '../../pures/InteractiveDialog/InteractiveDialog'
import { GridSelectionHLPure } from '../../pures'
import CheckBoxHLPure from '../../pures/checkBoxHL/checkBoxHL.pure'
import './digital-vault-document.view.css'

/**
 * @function HeaderColumns
 * @description Renderiza el encabezado de las columnas del grid
 * @param {{title: string}} props
 * @returns {JSX.Element}
 */
const HeaderColumns = (props) => {
  return (
    <span className='grid-headers'>{props.title}</span>
  )
}

/**
 * @function CellDocumentWithCheckbox
 * @description Renderiza una celda con checkbox y nombre del documento (solo lectura)
 * @param {{dataItem: Object}} props
 * @returns {JSX.Element}
 */
const CellDocumentWithCheckbox = (props) => {
  const { dataItem } = props

  return (
    <td>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0' }}>
        <CheckBoxHLPure
          valueCheckBox={dataItem}
          checkedState={dataItem.required || false}
          disabled={true}
          onChangeHandler={() => { }}
        />
        <div>
          <p className='grid-cell-titles-margin-left-thirdParty-title grid-cell-title'>
            {dataItem.documentTemplateName || 'Sin nombre'}
          </p>
        </div>
      </div>
    </td>
  )
}

/**
 * @function RequestDetailsDialog
 * @description Modal para ver los detalles de una solicitud de documentos a terceros (solo lectura)
 * @param {{
 *   showDialog: boolean,
 *   onClose: function,
 *   requestData: {
 *     documentName: string,
 *     instructions: string,
 *     isFreeLoad: boolean,
 *     usersDocuments: Array<{
 *       recipientId: number,
 *       fullName: string,
 *       userEmail: string,
 *       documents: Array<{
 *         id: number,
 *         documentTemplateName: string,
 *         status: string,
 *         required: boolean,
 *         createdDate: string,
 *         updatedDate: string
 *       }>
 *     }>
 *   }
 * }} props
 * @returns {JSX.Element|null}
 */
const RequestDetailsDialog = (props) => {
  const {
    showDialog,
    onClose,
    requestData
  } = props

  const { t } = useTranslation()

  if (!showDialog || !requestData) {
    return null
  }

  const { usersDocuments = [], infoType, limitDate } = requestData

  // Preparar todos los documentos de todos los usuarios para mostrar en un solo grid
  const allDocuments = usersDocuments.flatMap(user =>
    (user.documents || []).map(doc => ({
      ...doc,
      userName: user.fullName,
      userEmail: user.userEmail
    }))
  )

  const AllHeadersColumns = (props) => <HeaderColumns {...props} />

  /**
   * Formatea una fecha de YYYY-MM-DD a dd/mmm/yyyy
   * @param {string} dateStr - Fecha en formato YYYY-MM-DD
   * @returns {string} Fecha formateada o string vacío
   */
  const formatLimitDate = (dateStr) => {
    if (!dateStr) return ''

    try {
      const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
      const [year, month, day] = dateStr.split('-')

      if (!year || !month || !day) return ''

      const monthIndex = parseInt(month) - 1
      const monthName = months[monthIndex] || ''

      return `${day}/${monthName}/${year}`
    } catch (error) {
      return ''
    }
  }

  const formattedLimitDate = formatLimitDate(limitDate)

  return (
    <InteractiveDialog
      title={t('documentPanelBarDocumentsRequested.modal.details.title', { defaultValue: 'Detalles de la solicitud' })}
      dialogSize='S'
      onClose={onClose}
      cancelBtnTitle={t('button.close', { defaultValue: 'Cerrar' })}
    >
      <div style={{ marginBottom: '16px' }}>
        <div >
          <label className='inputHLPure-label'>
            {t('documentPanelBarDocumentsRequested.modal.details.requestedUser', { defaultValue: 'Usuario solicitado' })}
          </label>
          <p style={{ margin: '4px 0', fontSize: '14px', color: '#2C353C' }}>
            {usersDocuments.map(u => u.userEmail).join(', ')}
          </p>
        </div>

      </div>

      <div >
        <label className='inputHLPure-label'>
          {t('documentPanelBarDocumentsRequested.modal.details.documents', { defaultValue: 'Documento(s) solicitado(s)' })}
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px', marginLeft: '5px' }}>
          <CheckBoxHLPure
            valueCheckBox={{}}
            checkedState={true}
            disabled={true}
            onChangeHandler={() => { }}
          />
          <p style={{ margin: 0, fontSize: '14px', color: '#2C353C' }}>
            {infoType}
          </p>
        </div>
      </div>

      <GridSelectionHLPure
        skip={0}
        take={4}
        pageable={allDocuments.length > 4}
        dataGrid={allDocuments}
        noRecordsMessage={t('documentPanelBarDocumentsRequested.modal.details.noDocuments', { defaultValue: 'No hay documentos en esta solicitud' })}

        cellColumnOne={(props) => <CellDocumentWithCheckbox {...props} />}
        headerColumnOne={AllHeadersColumns}
        widthColumnOne={'auto'}
        minResizableWidth1={'auto'}

        styleGrid={{ height: 'auto', maxHeight: '400px' }}
        onSelectedItem={() => { }}
        setNameComponentUser={() => { }}
        setShowDetails={() => { }}
      />
      <div style={{ marginBottom: '12px' }}>
        <label className='inputHLPure-label'>
          {t('documentPanelBarDocumentsRequested.modal.details.limitDate', { defaultValue: 'Fecha límite' })}
        </label>
        <p style={{ margin: '4px 0', fontSize: '14px', color: '#2C353C' }}>
          {formattedLimitDate || t('documentPanelBarDocumentsRequested.modal.details.noLimitDate', { defaultValue: 'Sin fecha límite' })}
        </p>
      </div>
    </InteractiveDialog>
  )
}

export default RequestDetailsDialog
